var map = {
	"./applied-science": [
		5056,
		5056
	],
	"./applied-science.tsx": [
		5056,
		5056
	],
	"./art-and-design": [
		6185,
		6185
	],
	"./art-and-design.tsx": [
		6185,
		6185
	],
	"./biology": [
		1670,
		1670
	],
	"./biology.tsx": [
		1670,
		1670
	],
	"./business": [
		8469,
		8469
	],
	"./business.tsx": [
		8469,
		8469
	],
	"./chemistry": [
		8383,
		8383
	],
	"./chemistry.tsx": [
		8383,
		8383
	],
	"./computer-science": [
		7246,
		7246
	],
	"./computer-science.tsx": [
		7246,
		7246
	],
	"./design-and-technology": [
		7067,
		7067
	],
	"./design-and-technology.tsx": [
		7067,
		7067
	],
	"./drama": [
		777,
		777
	],
	"./drama.tsx": [
		777,
		777
	],
	"./english-language": [
		3284,
		3284
	],
	"./english-language.tsx": [
		3284,
		3284
	],
	"./english-literature": [
		1972,
		1972
	],
	"./english-literature.tsx": [
		1972,
		1972
	],
	"./geography": [
		6475,
		6475
	],
	"./geography.tsx": [
		6475,
		6475
	],
	"./history": [
		3896,
		3896
	],
	"./history.tsx": [
		3896,
		3896
	],
	"./mathematics": [
		3453,
		3453
	],
	"./mathematics.tsx": [
		3453,
		3453
	],
	"./physics": [
		2716,
		2716
	],
	"./physics.tsx": [
		2716,
		2716
	],
	"./psychology": [
		5676,
		5676
	],
	"./psychology.tsx": [
		5676,
		5676
	],
	"./religious-studies": [
		2817,
		2817
	],
	"./religious-studies.tsx": [
		2817,
		2817
	],
	"./welsh": [
		2452,
		2452
	],
	"./welsh-second-language": [
		5924,
		5924
	],
	"./welsh-second-language.tsx": [
		5924,
		5924
	],
	"./welsh.tsx": [
		2452,
		2452
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8422;
module.exports = webpackAsyncContext;